import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "boost-your-woocommerce-shop",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#boost-your-woocommerce-shop",
        "aria-label": "boost your woocommerce shop permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Boost your WooCommerce Shop`}</h1>
    <p><strong parentName="p">{`Boostimer`}</strong>{` is a product wise availability plugin which shows a beautiful countdown and lets you know when your unavailable product will be restocked!`}</p>
    <p>{`It also lets you sell limited-time products during a fixed time schedule countdown in your WooCommerce shop.`}</p>
    <p>{`Using this plugin, it’s easy to know when the required product will be available or restocked in the store.`}</p>
    <p>{`Furthermore, offering products on a limited sale time with a catchy countdown can create a sense of urgency which can trigger the user to make the purchase right away.`}</p>
    <h2 {...{
      "id": "features",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features",
        "aria-label": "features permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features`}</h2>
    <ul>
      <li parentName="ul">{`Display a countdown timer to highlight when the product will be restocked.`}</li>
      <li parentName="ul">{`Display a countdown timer to highlight sale products purchase availability end days and time.`}</li>
      <li parentName="ul">{`Display stock timer automatically after sale timer when stock goes zero.`}</li>
      <li parentName="ul">{`Manages restock and sell countdown for stock quantity`}</li>
      <li parentName="ul">{`Display sale timer and restock timer countdown for Simple Product`}</li>
      <li parentName="ul">{`Display restock timer countdown for Variable Product`}</li>
      <li parentName="ul">{`Display Sale timer countdown for External/Affiliate Product`}</li>
      <li parentName="ul">{`Customize Sale Timer and Restock Timer title`}</li>
      <li parentName="ul">{`Works seamlessly with `}<a parentName="li" {...{
          "href": "https://woocommerce.com/products/woocommerce-subscriptions/"
        }}>{`WooCommerce Subscriptions`}</a>{` product - Simple, Variable.`}</li>
      <li parentName="ul">{`and much more 🔥`}</li>
    </ul>
    <br />
    <p><a parentName="p" {...{
        "href": "/getting-started"
      }}>{`Get started now!`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      